import { useTranslation } from 'react-i18next'
import { common } from '@ocean/ui'
import { namespace } from 'modules/simulatorTrainings/common/localization'
import { Wrapper, ButtonWrapper, Support, SupportLinkWrapper } from './WartsilaButtonWrapper.styled'

const { Typography } = common

const I18_PATH = `${namespace}:simulatorTraining`
const WARTSILA_SUPPORT_LINK = 'https://csms.fos.transas.com/lms/v1/sl/support'

export type Direction = 'left' | 'right'

type WartsilaButtonWrapperProps = {
  direction?: Direction
  inactive?: boolean
  animated?: boolean
  dataTest?: string
}

const WartsilaButtonWrapper: React.FC<WartsilaButtonWrapperProps> = props => {
  const { children, direction, inactive, animated, dataTest } = props
  const { t } = useTranslation()

  return (
    <Wrapper inactive={inactive} data-test={dataTest || 'WartsilaButtonWrapperWrapper'}>
      <ButtonWrapper direction={direction} animated={animated}>
        {children}
      </ButtonWrapper>
      <Support>
        <SupportLinkWrapper>
          <Typography color='wartsilaOrange' variant='h3' hover='darken'>
            <a
              data-test='WartsilaButtonWrapperSupportLink'
              href={WARTSILA_SUPPORT_LINK}
              target='_blank'
              rel='noreferrer noopener'
            >
              {t(`${I18_PATH}.getHelp`)}
            </a>
          </Typography>
        </SupportLinkWrapper>
      </Support>
    </Wrapper>
  )
}

export default WartsilaButtonWrapper
